import useCart from '@hooks/cart/useCart';
import useShop from '@hooks/shop/useShop';
import { cartActions } from '@store/cart/cartSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

function usePrepareWithCart(shopId: string) {
  const cart = useCart(shopId);
  const shop = useShop(shopId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (cart && shop) {
      dispatch(cartActions.prepareWithCart({ shop, cart }));
    }
  }, [cart, shop]);
}

export default usePrepareWithCart;
